import React from 'react';
import { Check } from 'lucide-react';
export function WhyEpic() {
  const benefits = ['Premium materials sourced for desert climates', 'Clean, reliable, and respectful installation crews', 'Deep local knowledge of Las Vegas soil and HOA requirements', 'Full-service: from pavers to pool plaster, one company handles it all'];
  return <section className="py-20 md:py-28 bg-white" data-id="element-214">
      <div className="container mx-auto px-4" data-id="element-215">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-216">
          <div className="w-full lg:w-1/2" data-id="element-217">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-square md:aspect-[4/3] lg:aspect-square" data-id="element-218">
              <img src="https://cdn.magicpatterns.com/uploads/2wcLmpryFfsqyfKtKCzNjz/Screenshot_2026-06-19_100511.png" alt="Epic Pavers crew member prepping a front-yard paver installation in Las Vegas" className="w-full h-full object-cover" data-id="element-219" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 to-transparent flex items-end p-8" data-id="element-220">
                <p className="text-white font-bold text-xl md:text-2xl font-heading" data-id="element-221">
                  Craftsmanship you can stand on.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-222">
            <h2 className="text-3xl md:text-5xl font-extrabold font-heading text-charcoal mb-6 tracking-tight" data-id="element-223">
              Why Choose Epic Pavers?
            </h2>
            <p className="text-lg text-charcoal/80 mb-8 leading-relaxed" data-id="element-224">
              We don't just lay stone; we build the foundation for your outdoor
              lifestyle. Our commitment to premium finishes and reliable service
              has made us a trusted name across the valley.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-225">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-4" data-id="element-226">
                  <div className="w-6 h-6 rounded-full bg-teal/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-227">
                    <Check className="w-4 h-4 text-teal" data-id="element-228" />
                  </div>
                  <span className="text-charcoal font-medium text-lg" data-id="element-229">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="bg-sand p-6 rounded-xl border-l-4 border-teal" data-id="element-230">
              <p className="text-charcoal font-bold italic" data-id="element-231">
                "We take pride in doing it right the first time. No shortcuts,
                just epic results."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}